import { useState } from "react";
import { useForm } from "react-hook-form";
import LavorisService from "../../services/LavorisService";
import { useNavigate } from "react-router-dom";
import { INDEX } from "../../constants/routes";
import { Link } from "react-router-dom";
import InputCheckbox from "../../components/others/InputCheckbox/InputCheckbox";
import useDisabledButton from "./useDisabledButton.hook";
import { useModal } from "../../hooks";
import { modalURLs } from "../others/resetPassword/utils/modals.type";
import PasswordExpirationAlert from "../others/resetPassword/passwordExpirationAlert";
import Spinner from "../../components/others/Spinner/Spinner";


const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const { disabled, setDisabled } = useDisabledButton();
  const { isActive, closeModal, openModal } = useModal();
  const [email, setEmail] = useState(null);
  const [username, setUsername] = useState("");
  const MAX_RETRIES = 4;
  let retryCount = 0;

  const onSubmit = async (data: any) => {
    try {
      setLoginError(false);
      setLoginErrorMsg(false);
      setDisabled(true);
      const loginTokens = await LavorisInstance.Auth.login(data);
      if (loginTokens.requires2FA) {
        navigate("/login/2fa", { state: { userId: loginTokens.userId, email: loginTokens.email } });

        return;
      };

      if (loginTokens.requiresNewPassword) {
        setEmail(loginTokens.email);
        setUsername(data.username);
        return openModal(modalURLs.PASSWORD_EXPIRATION);
      };

      const response = await LavorisInstance.User.getProfile(loginTokens);

      if (response === "user not authorized to login in") {
        setLoginError(true);
      } else {
        setLoginError(false)
        navigate(INDEX);
      }
      retryCount = 0
    } catch (e: any) {
      console.log(e);
      if (retryCount < MAX_RETRIES) {
        retryCount += 1;
        setTimeout(() => {
          onSubmit(data);
        }, 2000);
      } else {
        if (e?.response?.data?.message === 'Company not approved') {
          setLoginErrorMsg(true);
        } else {
          setLoginError(true);
          const { statusCode } = e;
          if (statusCode === 401 || statusCode === 404) setLoginError(true);
        }
      }
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <div className="login">
        <div className="messages_slide">
          {/* <video src="https://www.lavoris.com.ar/frontend/images/video-24-baja.mp4" className="main-video" autoPlay muted loop poster="/frontend/images/video-cover.jpg"></video> */}

        </div>
        <div className="login_right">
          <div className="company_logo">
            <Link to={INDEX}>
              <img src="/images/Logo_Lavorix.png" alt="Lavorix" className="logo" />
            </Link>
            <p>Portal de clientes</p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="form-row login_form">
            <div className="form-group">
              {/* <h4> Nuestro portal se encuentra con inconvenientes técnicos.</h4>
              <h4> Por favor, regrese en unos minutos.</h4>
              <h4> Disculpas por los inconvenientes ocasionados.</h4> */}
              <label htmlFor="username">Tu usuario</label>
              <input className="form-control" type="text" {...register("username")} />
            </div>
            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <div style={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center' }}>
                <input 
                  className="form-control" 
                  type={showPassword ? "text" : "password"} 
                  {...register("password")}
                  style={{ 
                    paddingRight: '45px',
                    width: '100%',
                    flex: 1
                  }}
                />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPassword(!showPassword);
                  }}
                  type="button"
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10,
                    height: '30px',
                    width: '30px',
                    minWidth: '30px',
                    pointerEvents: 'auto'
                  }}
                  tabIndex={-1}
                  aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                >
                  {showPassword ? (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      style={{ color: '#666', pointerEvents: 'none' }}
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                  ) : (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      style={{ color: '#666', pointerEvents: 'none' }}
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  )}
                </button> 
              </div>
            </div>
            <button type="submit" disabled={disabled}>
              {disabled ? <Spinner /> : "Ingresar"}
            </button>
            {loginError ? (
              <span className="error-login">
                Credenciales incorrectas o usuario no aprobado
              </span>
            ) : null}
            {loginErrorMsg ? (
              <span className="error-login">
                Tu compañía no está aprobada
              </span>
            ) : null}
          </form>
          <div className="login_options">
            <div className="mt-6 flex flex-row justify-between">
              <InputCheckbox
                register={register}
                fieldName="checkbox"
                defaultChecked
                label="Recuerdame"
              />
              <Link to="/RecuperarContraseña" className="underline  cursor-pointer">
                Olvidé mi contraseña
              </Link>
            </div>
          </div>
          <div className="new_clients">
            <p>
              ¿Eres nuevo en Lavorix?{" "}
              <Link to="/Alta">
                Regístrate aquí
              </Link>
            </p>
          </div>
        </div>
      </div>



      {isActive(modalURLs.PASSWORD_EXPIRATION) && (
        <PasswordExpirationAlert
          toggleModal
          urlTittle={modalURLs.PASSWORD_EXPIRATION}
          handleClose={() => [closeModal(modalURLs.PASSWORD_EXPIRATION), setEmail(null), setUsername("")]}
          email={email}
          username={username}
        />
      )}

    </>
  );
};

export default Login;
